import { render, staticRenderFns } from "./RecentReviews.vue?vue&type=template&id=29ca314a"
import script from "./RecentReviews.vue?vue&type=script&lang=js"
export * from "./RecentReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports